import { useEffect, useState } from 'react';
import { Catalogue } from '@ynap/api-utils';
import { useConfig, useAppState } from '@ynap/immutables-provider';
import { raygun } from '@ynap/clientside-monitoring';

const configSelector = (config) => ({
    baseUrl: config.global.services.commerce.baseUrl,
    brandId: config.global.application.brandId,
    clientId: config.global.services.commerce.clientId,
});

export const useProductDetails = ({ partNumber }) => {
    const [details, setDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const { country, langISO } = useAppState();
    const { baseUrl, brandId, clientId } = useConfig(configSelector);

    useEffect(() => {
        if (partNumber) {
            getProductDetails({ baseUrl, brandId, clientId, country, partNumber, langISO, setLoading }).then((productDetails) => setDetails(productDetails));
        }
    }, [country, partNumber]);

    return {
        details,
        isProductDetailsLoading: loading,
    };
};

const getProductDetails = async ({ baseUrl, brandId, clientId, country, partNumber, langISO, setLoading }) => {
    setLoading(true);
    const productDetails = await fetchProductDetails({ partNumber, baseUrl, brandId, clientId, country, langISO });
    setLoading(false);
    return productDetails;
};

const fetchProductDetails = async ({ partNumber, baseUrl, brandId, clientId, country, langISO }) => {
    try {
        const response = await fetch(Catalogue.getDetailsByPartNumber({ baseUrl, brandId, clientId, country, partNumber, options: { locale: langISO } }));
        if (!response.ok) {
            raygun.helpers.agent('send', {
                error: new Error(`getDetailsByPartNumber in fetchProductDetails error`),
                tags: [`error-getDetailsByPartNumber`, `partNumber: ${partNumber}`, `statusCode: ${response.status}`],
            });
            return;
        }

        const json = await response.json();

        return json.products[0];
    } catch (err) {
        raygun.helpers.agent('send', {
            error: new Error(`getDetailsByPartNumber in fetchProductDetails error`),
            tags: [`error-getDetailsByPartNumber`, `partNumber: ${partNumber}`],
            customData: {
                err,
            },
        });
    }
};
